import { render, staticRenderFns } from "./payslip-list.vue?vue&type=template&id=61cae07d&scoped=true"
import script from "./payslip-list.vue?vue&type=script&lang=js"
export * from "./payslip-list.vue?vue&type=script&lang=js"
import style0 from "./payslip-list.vue?vue&type=style&index=0&id=61cae07d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cae07d",
  null
  
)

export default component.exports